import { useEffect, useState } from 'react';
import { PRODUCT_DETAILS_SCROLL_HEADER_HEIGHT } from '../components/ProductDetailsScrollHeader/productDetailsScrollHeader.styles';

interface UseProductDetailsScrollHeaderParams {
  titleElement: HTMLElement | null;
  scrollElement: HTMLElement | null;
}

const useProductDetailsScrollHeader = ({
  titleElement,
  scrollElement,
}: UseProductDetailsScrollHeaderParams) => {
  const [isTitleVisible, setIsTitleVisible] = useState(true);

  useEffect(() => {
    if (!titleElement || !scrollElement) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsTitleVisible(entry.isIntersecting);
      },
      {
        root: scrollElement,
        rootMargin: `-${PRODUCT_DETAILS_SCROLL_HEADER_HEIGHT}px 0px 0px 0px`,
      },
    );

    observer.observe(titleElement);

    return () => observer.disconnect();
  }, [titleElement, scrollElement]);

  return !isTitleVisible;
};

export default useProductDetailsScrollHeader;
